import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from '@auth0/auth0-angular';
import { Router } from '@angular/router';
import { LoadingService } from '@core/services/loading/loading-api';
import { SharedModule } from '@shared/shared.module';
import { FormsModule } from '@angular/forms';
import { MaterialsModule } from '@shared/materials.module';

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.html',
  styleUrls: ['./access-denied.scss'],
  standalone: true,
  imports: [CommonModule, SharedModule, FormsModule, MaterialsModule],
})
export class AccessDeniedComponent implements OnInit {

  constructor(
    public auth: AuthService,
    public router: Router,
    public loadingService: LoadingService
  ) { }

  ngOnInit(): void {
  }

  forceLogout(): void {
    this.loadingService.setLoading(true);
    setTimeout(() => {
      this.clear();
      this.auth.logout();
      this.loadingService.setLoading(false);
    })
  }

  clear() {
    sessionStorage.clear();
  }

}
